module.exports = __webpack_public_path__ + "img/mapa-nedetel.1e2fa9c3.png";